// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  --button-font-family: var(--font-family);
  --button-background-primary: var(--orange);
  --button-background-primary-disabled: var(--gray);
  --button-color-primary: var(--white);
  --button-color-primary-disabled: var(--light-gray);
  --button-spinner-border-color-main: #f3f3f3;
  --button-spinner-border-color-section: #bdbdbd;
  display: inline-block;
  height: 60px;
  padding: 14px 20px 12px;
  border: none;
  border-radius: 40px;

  font-family: var(--button-font-family);
  color: var(--button-color-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: normal;
  text-align: center;
  outline: none;
  cursor: pointer;
  box-shadow: none;
  background: var(--button-background-primary);
  width: 100%;
}

.btn[disabled] {
  cursor: not-allowed;
  background-color: var(--button-background-primary-disabled);

}

@-webkit-keyframes buttonSpin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes buttonSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.btn .button-spinner {
  display: inline-block;
  border-width: 4px;
  border-style: solid;
  border-color: var(--button-spinner-border-color-main);
  border-top-color: var(--button-spinner-border-color-section);
  border-radius: 50%;
  -webkit-animation: buttonSpin 2s linear infinite;
  animation: buttonSpin 2s linear infinite;
  height: 18px;
  width: 18px;
}

.btn .inner-container {
  display: inline-flex;
  align-items: center;

  .image-container {
    margin-right: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.primary-button.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,iDAAiD;EACjD,oCAAoC;EACpC,kDAAkD;EAClD,2CAA2C;EAC3C,8CAA8C;EAC9C,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;;EAEnB,sCAAsC;EACtC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2DAA2D;;AAE7D;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qDAAqD;EACrD,4DAA4D;EAC5D,kBAAkB;EAClB,gDAAgD;EAChD,wCAAwC;EACxC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".btn {\n  --button-font-family: var(--font-family);\n  --button-background-primary: var(--orange);\n  --button-background-primary-disabled: var(--gray);\n  --button-color-primary: var(--white);\n  --button-color-primary-disabled: var(--light-gray);\n  --button-spinner-border-color-main: #f3f3f3;\n  --button-spinner-border-color-section: #bdbdbd;\n  display: inline-block;\n  height: 60px;\n  padding: 14px 20px 12px;\n  border: none;\n  border-radius: 40px;\n\n  font-family: var(--button-font-family);\n  color: var(--button-color-primary);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: normal;\n  text-align: center;\n  outline: none;\n  cursor: pointer;\n  box-shadow: none;\n  background: var(--button-background-primary);\n  width: 100%;\n}\n\n.btn[disabled] {\n  cursor: not-allowed;\n  background-color: var(--button-background-primary-disabled);\n\n}\n\n@-webkit-keyframes buttonSpin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes buttonSpin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.btn .button-spinner {\n  display: inline-block;\n  border-width: 4px;\n  border-style: solid;\n  border-color: var(--button-spinner-border-color-main);\n  border-top-color: var(--button-spinner-border-color-section);\n  border-radius: 50%;\n  -webkit-animation: buttonSpin 2s linear infinite;\n  animation: buttonSpin 2s linear infinite;\n  height: 18px;\n  width: 18px;\n}\n\n.btn .inner-container {\n  display: inline-flex;\n  align-items: center;\n\n  .image-container {\n    margin-right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
